import { render, staticRenderFns } from "./TreeCardStatusBadge.vue?vue&type=template&id=4d965970&scoped=true&"
import script from "./TreeCardStatusBadge.vue?vue&type=script&lang=ts&"
export * from "./TreeCardStatusBadge.vue?vue&type=script&lang=ts&"
import style0 from "./TreeCardStatusBadge.vue?vue&type=style&index=0&id=4d965970&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d965970",
  null
  
)

export default component.exports